import { ShowMoreForm } from "./show-more-form";
import { ShowMoreHandler } from "./show-more-handler";
import { ShowMoreListener } from "./show-more-listener";

/**
 * Show More Setup (V2)
 * feature の初期化入口
 */
export class ShowMoreSetup {
    public static observer: MutationObserver | null = null;

    public form: ShowMoreForm;

    public handler: ShowMoreHandler;

    public listener: ShowMoreListener;

    public constructor(root: HTMLElement) {
        this.form = new ShowMoreForm(root);
        this.handler = new ShowMoreHandler(this.form);
        this.listener = new ShowMoreListener(this.form, this.handler);
    }

    public init(): void {
        if (this.form.isInitialized()) return;
        this.handler.bootstrap();
        this.listener.register();
        this.form.markInitialized();
    }

    public static init(scope: Document | HTMLElement = document): void {
        ShowMoreForm.getRoots(scope).forEach((target) => {
            const setup = new ShowMoreSetup(target);
            setup.init();
        });
    }

    public static observe(scope: Document | HTMLElement = document): void {
        if (this.observer instanceof MutationObserver) return;

        const root = scope instanceof Document ? scope.body : scope;
        if (!(root instanceof HTMLElement)) return;

        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof HTMLElement)) return;

                    if (node.matches("show-more")) {
                        ShowMoreSetup.init(node);
                    }

                    if (new ShowMoreForm(node).getNestedRoots(node).length > 0) {
                        ShowMoreSetup.init(node);
                    }
                });
            });
        });

        this.observer.observe(root, {
            childList: true,
            subtree: true,
        });
    }
}
